export const PRIVATE_PROFILE_DISCLAIMER_DIALOG =
  'PRIVATE_PROFILE_DISCLAIMER_DIALOG';
